import './App.scss';

import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

import { clearSessionExpired } from "../slices/authSlice";

import { BrowserRouter as Router} from "react-router-dom";
import { Routes } from "react-router-dom";
import { Route } from "react-router-dom";
import { Navigate } from "react-router-dom";

import { Box } from "@mui/material";

// import { Drawer } from "@mui/material";
import { Drawer } from "../common-components/Drawer/Drawer";
import { Alert } from "../common-components/Alert/Alert";
import { Modal } from "../common-components/Modal/Modal";

import Layout from "../layout/Layout";
import Departures from "../departures/Departures";
import Details from "../details/Details";
import DetailsMobile from "../details/components/DetailsMobile/DetailsMobile";
import QuantityPage from "../pages/QuantityPage/QuantityPage";
import ModalExpired from "../components/ModalExpired/ModalExpired";
import Vehicles from "../vehicles/Vehicles";
import StatisticPage from "../pages/StatisticPage/StatisticPage";
import TransportStatistic from "../pages/TransportStatistic/TransportStatistic";
import Preventive from "../preventive/Preventive";
import PreventiveDetails from "../preventive/components/PreventiveDetails/PreventiveDetails";
import Auth from "../auth/Auth";

const App = () => {
    const dispatch = useDispatch();
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const data = useSelector((state) => state.user.data);
    const token = useSelector((state) => state.auth.token);
    const isExpired = useSelector((state) => state.auth.isSessionExpired);
    const showAlert = useSelector((state) => state.alert.showAlert);

    console.log("Permissions:", JSON.stringify(data?.relationships?.role?.permissions, null, 2));

    const handleCloseSessionModal = () => {
        dispatch(clearSessionExpired());
    }

    return (
        <Router>
            <Box className={"App"}>
                <Routes>
                    <Route
                        path="/"
                        element={
                            <Navigate to={"/Auth"} replace/>
                        }
                    />
                    <Route
                        path="/Auth"
                        element={
                            !isAuthenticated && !token ? <Auth/> : <Navigate to="/Departures" replace/>
                        }
                    />
                    <Route
                        path="/Departures"
                        element={
                            isAuthenticated || token ? <Layout children={<Departures/>}/> : <Navigate to="/Auth" replace/>
                        }
                    />
                    <Route
                        path="/DetailsReport/:id"
                        element={
                            isAuthenticated || token ? <Layout children={<Details/>}/> : <Navigate to="/Auth" replace/>
                        }
                    />
                    <Route
                        path="/DetailsMobile/:id"
                        element={
                            isAuthenticated || token ? <Layout children={<DetailsMobile/>}/> : <Navigate to={"/Auth"} replace/>
                        }
                    />
                    <Route
                        path="/Preventive"
                        element={
                            isAuthenticated || token ? <Layout children={<Preventive/>}/> : <Navigate to="/Auth" replace/>
                        }
                    />
                    <Route
                        path="/Vehicles"
                        element={
                            isAuthenticated || token ? <Layout children={<Vehicles/>}/> : <Navigate to="/Auth" replace/>
                        }
                    />
                    <Route
                        path="/DetailsPreventive/:id"
                        element={
                            isAuthenticated || token ? <Layout children={<PreventiveDetails/>}/> : <Navigate to="/Auth" replace/>
                        }
                    />
                    <Route
                        path="/QuantityPage"
                        element={
                            isAuthenticated || token ? (
                                <Layout
                                    children={<QuantityPage/>}
                                />
                            ) : <Navigate to="/" />
                        }
                    />
                    <Route
                        path="/StatisticPage"
                        element={
                            isAuthenticated || token ? (
                                <Layout
                                    children={<StatisticPage/>}
                                />
                            ) : <Navigate to="/" />
                        }
                    />
                    <Route
                        path="/TransportStatistic"
                        element={
                            isAuthenticated || token ? (
                                <Layout
                                    children={<TransportStatistic/>}
                                />
                            ) : <Navigate to="/"/>
                        }
                    />
                </Routes>
                {showAlert && (
                    <Alert/>
                )}
                <Modal/>
                {/*<Drawer children={content} open={isOpen} anchor={"right"} onClose={handleCloseDrawer}/>*/}
                <Drawer/>
                {isExpired && (
                    <ModalExpired
                        isOpen={isExpired}
                        onClose={handleCloseSessionModal}
                    />
                )}
            </Box>
        </Router>
    )
}

export default App;
